import React from 'react';

const Container = ({ className, children, variant = 'default' }) => {
  const variants = {
    tight: 'px-1 sm:px-2 lg:px-6',     // Ultra-minimal for lists
    default: 'px-2 sm:px-4 lg:px-8',   // Minimal mobile padding
    loose: 'px-4 sm:px-6 lg:px-8'      // Slightly more padding for forms
  };

  return (
    <div className={`${variants[variant]} ${className || ''}`}>
      <div className="mx-auto w-full max-w-none sm:max-w-none lg:max-w-7xl">
        {children}
      </div>
    </div>
  );
};

export default Container;